// @flow
import React from 'react';
import ListModel from 'Stores/ListModel';
import TeaserModel from 'Stores/TeaserModel';
import Item from './item';
import DealerModel from 'Stores/DealerModel';

type Props = {
  teasers: Array<Object>,
  type: string,
  onOpenContact: () => void,
  deeplinkId?: number,
  dealer: DealerModel,
};

type State = {
  teasers: ListModel,
};

export default class Teaser extends React.Component<Props, State> {
  state = {
    teasers: new ListModel(),
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      teasers: new ListModel(props.teasers, TeaserModel),
      currentIndex: 0,
      consumptionTexts: [],
    };
  }

  renderTeasers = (teasers) => {
    const { onOpenContact, consumptionText, dealer } = this.props;
    const { consumptionTexts } = this.state;

    return teasers.reduce((acc, cur) => {
      if (cur.hidden) {
        return acc;
      }

      return [
        ...acc,
        <Item
          dealer={dealer}
          teaser={cur}
          onOpenContact={onOpenContact}
          key={cur.id}
          id="teaser"
          consumption={consumptionText || consumptionTexts[cur.id]}
        />,
      ];
    }, []);
  };

  render() {
    const { teasers } = this.state;
    const { deeplinkId } = this.props;

    return <div id={deeplinkId}>{this.renderTeasers(teasers)}</div>;
  }
}
